import { Component, OnInit } from '@angular/core';
import { UserService } from '../_services/user.service';
import { NotificationService } from 'src/app/_services/notification.service'
import { User } from '../_models';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-user-detail',
  templateUrl: './user-detail.component.html',
  styleUrls: ['./user-detail.component.css']
})
export class UserDetailComponent implements OnInit {

  cUser:User ;
  loading:boolean = false;
  submitted:boolean = false;

  userID: string;

  constructor(public service: UserService,  
    private notifyService : NotificationService,
    private fb: FormBuilder,
    private router: Router,
    private route:ActivatedRoute,
    public userService: UserService
    ) { }

  ngOnInit(): void {
    this.cUser = JSON.parse(localStorage.getItem('currentUser'));   

    this.route.paramMap.subscribe(param => {
      this.userID = param.get('userID');
      if(this.userID){
        this.loadUserdetails(this.userID);
      }      
    });
  }

  formModel = this.fb.group({
    Email: ['', [Validators.required, Validators.email]],
    FirstName: [''],
    LastName: [''],    
    Mobile:[''] ,
    Status:['',Validators.required]
  });



  loadUserdetails(userId){
    this.userService.getUserDetail(userId).subscribe(
      res => {
        if(res!= null){                             
             this.formModel.controls.FirstName.setValue(res.firstName);
             this.formModel.controls.LastName.setValue(res.lastName);
             this.formModel.controls.Mobile.setValue(res.phoneNumber);
             this.formModel.controls.Email.setValue(res.email);             
             this.formModel.controls.Status.setValue(res.status);
        }       
      },
      err => {
       //this.router.navigate(['/']);
      }
    );
  }

  
  onSubmit() {

    this.submitted =  true;

    if (!this.formModel.valid) {
      //  this.notifyService.showError("All fields are required.", "Error.")
        return;
      }          

    this.loading = true;
  
    var param = {
      Id:this.userID,
      UserName: this.formModel.value.UserName,
      PhoneNumber : this.formModel.value.Mobile,                  
      Email: this.formModel.value.Email,
      FirstName: this.formModel.value.FirstName,
      LastName: this.formModel.value.LastName,    
      Status : parseInt(this.formModel.value.Status) ,        
      createdBy : this.cUser.userId
    };
      
    this.userService.updateUser(param)
        .subscribe( 
            data => {              
              if(data){
     
                this.loading = false;                
     
                this.submitted = false;
                this.notifyService.showSuccess("Saved successfully", "CSP Portal");                            
            }
          },
            error => {                
                this.loading = false;  
                this.submitted = false;                           
            });          
    }  
    
    onClose(){
      this.router.navigate(['/users']);
    }

}
